
import {autocomplete} from "@algolia/autocomplete-js"

// import "@algolia/autocomplete-theme-classic" - moved to main stylesheet

function debouncePromise(fn, time){
    let timerId = undefined
    
    return function(...args){
        if(timerId){
            clearTimeout(timerId)
        }        
        return new Promise((resolve) => {
            timerId = setTimeout(() => resolve(fn(...args)), time)
        })        
    }
}
const debouncedFetch = debouncePromise(fetch, 300)


if(document.getElementById("search-autocomplete")){

    autocomplete({
        container: '#search-autocomplete',
        placeholder: 'Search for products',
        //debug: true,
        
        getSources({query}){
            return debouncedFetch(`/ajax/search?q=${query}`)
                .then(response => response.json())
                .then((data) => {
                    return [
                        {
                            sourceId: "lines",
                            getItems(){
                                return data
                            }, 
                            getItemUrl({ item }) {
                                return `/shop/all/products/${item.slug}`
                            },                           
                            templates: {
                                item({ item, html }){
                                    return html`<a href="/shop/all/products/${item.slug}" class="search-link">
                                        <div class="row align-items-center" onClick="window.location.href='/shop/all/products/${item.slug}'">
                                            <div class="col-auto">
                                                <img src="${getImage(item.filename, item.filetype)}" width="60" />
                                            </div>
                                            <div class="col">
                                                ${item.name}                                                
                                            </div>
                                            <div class="col-auto text-end">${getPrice(item.min_price, item.max_price)}</div>
                                        </div>
                                    </a>`
                                },
                                // footer(){
                                //     return "FOOTER"
                                // },
                                noResults(){
                                    return "No results"
                                }
                            }
                        }
                    ]                
                })
        }
    });

}


function getImage(filename, filetype){
    if(filename==null){
        return "/assets/images/no-image-s.jpg"
    } else {
        return `/assets/products/${filename}-s.${filetype}`
    }
}

function getPrice(minPrice, maxPrice){
    if(minPrice == maxPrice){
        return "$" + minPrice.toFixed(2)
    } else {
        return "From $" + minPrice.toFixed(2)
    }
}